import { fetchAuthSession } from 'aws-amplify/auth';

const getAccessToken = async () => {
  const session = await fetchAuthSession();
  const token = session?.tokens?.accessToken;
  if (!token) {
    throw new Error('No authenticated user');
  }
  return token.toString();
};

export default getAccessToken;
